// Aranabilir seçici (SearchSelect) saf mantığı — uzun listelerde (200+ gösterge kodu, katalog
// kategori ağacı) tarayıcının yerel <select>'i yerine (kullanıcı bulgusu 2026-10-08).
// Sıra: etiket/kod ÖNEKİ → kelime öneki → içeren; boş sorgu tüm listeyi (verilen sırada) döner.

export interface SearchSelectOption {
  value: string;
  label: string;
  /** monospace ikincil metin (gösterge kodu) */
  code?: string | undefined;
  /** sağda soluk metin (birim, sayım) */
  hint?: string | undefined;
  /** ağaç girintisi (0 = kök) */
  depth?: number | undefined;
  disabled?: boolean | undefined;
  /** bölüm başlığı (seçilemez satır); aynı gruptakiler başlığın altında, ilk görünüş sırasıyla */
  group?: string | undefined;
  /** satır üzerine gelince açıklama (`title`) */
  title?: string | undefined;
}

export function foldSearch(s: string): string {
  return s.trim().toLocaleLowerCase("tr-TR").replace(/ı/g, "i");
}

export function filterSearchOptions(
  query: string,
  options: readonly SearchSelectOption[],
  limit = 200,
): SearchSelectOption[] {
  const q = foldSearch(query);
  if (q === "") return options.slice(0, limit);
  const tiers: SearchSelectOption[][] = [[], [], []];
  for (const o of options) {
    const l = foldSearch(o.label);
    const c = o.code ? foldSearch(o.code) : "";
    if (l.startsWith(q) || (c !== "" && c.startsWith(q))) tiers[0]!.push(o);
    else if (l.split(/[\s/()·-]+/).some((w) => w.startsWith(q))) tiers[1]!.push(o);
    else if (l.includes(q) || c.includes(q) || (o.hint ? foldSearch(o.hint).includes(q) : false))
      tiers[2]!.push(o);
  }
  return tiers.flat().slice(0, limit);
}

/**
 * Bölümlü listede satırları grup ilk görünüş sırasına dizer (grup içi sıra korunur — arama
 * kademeleri bölüm içinde kalır). Hiçbir seçenekte `group` yoksa aynı dizi döner.
 */
export function orderByGroup(rows: SearchSelectOption[]): SearchSelectOption[] {
  if (!rows.some((o) => o.group !== undefined)) return rows;
  const order = new Map<string | undefined, number>();
  for (const o of rows) if (!order.has(o.group)) order.set(o.group, order.size);
  return rows
    .map((o, i) => ({ o, i }))
    .sort((a, b) => order.get(a.o.group)! - order.get(b.o.group)! || a.i - b.i)
    .map((x) => x.o);
}

/** Ardışık aynı gruptaki satırlar (`index` = listbox sırası; aria-activedescendant için). */
export function groupRuns(
  rows: readonly SearchSelectOption[],
): { group: string | undefined; items: { option: SearchSelectOption; index: number }[] }[] {
  const out: {
    group: string | undefined;
    items: { option: SearchSelectOption; index: number }[];
  }[] = [];
  rows.forEach((option, index) => {
    const last = out[out.length - 1];
    if (last && last.group === option.group) last.items.push({ option, index });
    else out.push({ group: option.group, items: [{ option, index }] });
  });
  return out;
}
